/**
 * Curated educational video shelves shown at the bottom of the three main
 * calculators.  Videos are embedded via privacy-preserving
 * youtube-nocookie.com with `rel=0` and `modestbranding=1` so playback
 * stays inside our page — no exit to youtube.com, no related-video
 * sidebar, no branded suggestions.
 *
 * Each entry ships a real YouTube video ID that has been web-verified as
 * a mainstream, educational, non-controversial lecture. To swap a video,
 * edit the `videoId` (11-char YouTube ID) and (optionally) the `title`
 * and `topic` here. Do not change the property shape.
 */

// Zakat — introductions, worked examples, asset-specific rulings.
export const ZAKAT_VIDEOS = [
  {
    videoId: 'O3jRAHt7VZ8',
    title: 'How to Calculate Zakat the Right Way',
    duration: 'Ramadan Reflections',
    topic: 'nisab, hawl and the 2.5% rule',
  },
  {
    videoId: 'EH1N5-d35e4',
    title: 'What Is Zakat? — The Third Pillar Explained',
    duration: 'Lecture',
    topic: 'purpose and obligations',
  },
  {
    videoId: 'F1HgxsoBUYQ',
    title: 'Zakat on Savings, Business & Investments',
    duration: 'Lecture',
    topic: 'asset-specific rulings',
  },
];

// Inheritance (Faraid) — foundations, shares, common questions.
export const INHERITANCE_VIDEOS = [
  {
    videoId: 'RUJARcYjWoM',
    title: 'Does Islamic Inheritance Favor Men Over Women?',
    duration: 'Explainer',
    topic: 'fixed shares and Quran 4:11',
  },
  {
    videoId: 'aKq3WK2PB4Q',
    title: 'Wills & Inheritance in Islam — Know Where You Stand',
    duration: 'Lecture',
    topic: 'shares, wasiyyah cap and heirs',
  },
  {
    videoId: 'nTpw2JFKnvA',
    title: 'Inheritance in Islam — A Reminder',
    duration: 'Short talk',
    topic: 'debts, executor and blocked heirs',
  },
];

// Wasiyyah (Islamic Will) — obligation, drafting, digital assets.
export const WILL_VIDEOS = [
  {
    videoId: '93Dek0hHjHY',
    title: 'Understanding Islamic Estate Planning',
    duration: 'Explainer',
    topic: 'estate mapping and legal transfer',
  },
];
